module.exports = __webpack_public_path__ + "static/img/PC-5.c92d23e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/PC-5.png
// module id = RLSI
// module chunks = 0